import { Navigate } from "react-router-dom";

const AuthorizeUser = ({ children }) => {
	
	const customer = localStorage.getItem("token");
	
	const type = localStorage.getItem("loginMode");

	if (customer && type) {
		
		
		return children;
	  
	
	}

	return <Navigate to={"/"} replace={true}></Navigate>;
};
export default AuthorizeUser;
